var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "form tab-content",
      attrs: { id: "pathway-simplified-cables" }
    },
    [
      _c(
        "v-layout",
        { staticStyle: { "padding-right": "20px" }, attrs: { column: "" } },
        [
          _c(
            "v-layout",
            {
              staticStyle: { "flex-wrap": "nowrap" },
              attrs: {
                row: "",
                "justify-space-between": "",
                "align-center": ""
              }
            },
            [
              _c("input-field", {
                attrs: {
                  value: "",
                  label: _vm.$t("CableList"),
                  size: "large",
                  inputType: "group"
                }
              }),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  staticClass: "ma-0",
                  attrs: {
                    small: "",
                    icon: "",
                    text: "",
                    color: "accent",
                    disabled:
                      _vm.readOnly ||
                      !_vm.cableTypeOptions ||
                      _vm.cableTypeOptions.length === 0
                  },
                  on: { click: _vm.addCable }
                },
                [_c("v-icon", [_vm._v("add_circle")])],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-layout",
            { attrs: { column: "" } },
            [
              _vm._l(_vm.cables, function(cable, index) {
                return _vm.cables.length > 0
                  ? _c(
                      "div",
                      { key: index, staticStyle: { padding: "10px 0 0 20px" } },
                      [
                        _c(
                          "v-card",
                          { attrs: { flat: "" } },
                          [
                            _c(
                              "v-layout",
                              {
                                attrs: {
                                  row: "",
                                  "align-center": "",
                                  "justify-space-around": ""
                                }
                              },
                              [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$tc("Cable", 1) + " " + (index + 1)
                                    )
                                  )
                                ]),
                                _vm._v(" "),
                                _c("input-field", {
                                  attrs: {
                                    label: "",
                                    "input-type": "select",
                                    size: "medium",
                                    "select-options": "list_cable_owner_type",
                                    placeholder: _vm.$t("SelectCableType"),
                                    "field-disabled": _vm.readOnly,
                                    clearable: false
                                  },
                                  model: {
                                    value: _vm.cables[index],
                                    callback: function($$v) {
                                      _vm.$set(_vm.cables, index, $$v)
                                    },
                                    expression: "cables[index]"
                                  }
                                }),
                                _vm._v(" "),
                                _c(
                                  "v-btn",
                                  {
                                    staticClass: "ma-0",
                                    attrs: {
                                      small: "",
                                      icon: "",
                                      text: "",
                                      color: "accent",
                                      disabled: _vm.readOnly
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.removeCable(index)
                                      }
                                    }
                                  },
                                  [_c("v-icon", [_vm._v("delete")])],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  : _vm._e()
              }),
              _vm._v(" "),
              _vm.cables.length === 0
                ? _c(
                    "v-layout",
                    {
                      staticClass: "pa-3",
                      attrs: { "align-center": "", "justify-center": "" }
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.$t("NoPathwaySimplifiedCables")) +
                          "\n      "
                      )
                    ]
                  )
                : _vm._e()
            ],
            2
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-63aa0991", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-63aa0991","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/Forms/_SpecialTabs/PathwaySimplifiedCables.vue
// module id = null
// module chunks = 